export const INGREDIENTS = [
  {
    image: require('../../../../asset/images/detail/rouge/rouge_point_img01.png'),
    title: 'CALENDULA OFFICINALIS FLOWER',
    desc: '피부결 개선에 도움을 줄 수 있으며 건조한 피부를 부드럽게 케어해줍니다.',
  },
  {
    image: require('../../../../asset/images/detail/rouge/rouge_point_img02.png'),
    title: 'SWEET ALMOND OIL',
    desc: '스위트 아몬드 오일은 고보습의 효과를 지닌 동시에 피부 자극이 적어 부드럽게 케어해줍니다.',
  },
  {
    image: require('../../../../asset/images/detail/rouge/rouge_point_img03.png'),
    title: 'AVOCADO OIL',
    desc: '피부 보습과 유연효과가 뛰어나 피부를 건강하게 가꿔줍니다.',
  },
  {
    image: require('../../../../asset/images/detail/rouge/rouge_point_img04.png'),
    title: 'COCONUT OIL',
    desc: '코코넛 오일에 함유된 라우르산과 카프릴산 성분이 피부를 건강하게 케어해줍니다.',
  },
  {
    image: require('../../../../asset/images/detail/rouge/rouge_point_img05.png'),
    title: 'BRAZILNUT SEED OIL',
    desc: '비타민E, 셀레늄과 오메가3 등의 성분이 함유되어 있어 피부를 건강하게 가꿔줍니다.',
  },
  {
    image: require('../../../../asset/images/detail/rouge/rouge_point_img06.png'),
    title: 'PASSION FRUIT SEED OIL',
    desc: '피부 보습에 탁월하며 흡수력이 좋아 사용감이 좋은 오일로 유연한 케어가 가능합니다.',
  },
];
